import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2, Text, Image, ButtonLink } from '@blueprint/ui';

const CustomBp1 = '480px';
const CustomBp2 = '650px';

export const FooterContainer = styled.div(
    ({ theme: { mq, borderRadius, spacing, colors } }) => {
        return css`
            background-color: ${colors['graphic-background-contrast']};
            position: relative;
            display: flex;
            flex-direction: column;
            min-height: 500px;
            border-radius: ${borderRadius['400']};
            margin: 70px ${spacing['16px']} ${spacing['24px']}
                ${spacing['16px']};
            overflow: hidden;

            @media (min-width: ${CustomBp1}) {
                min-height: 380px;
            }

            @media (min-width: ${CustomBp2}) {
                min-height: 320px;
            }

            ${mq.medium} {
                padding: 0;
                margin: 70px 0 ${spacing['24px']} 0;
            }

            ${mq.large} {
                height: 275px;
            }
        `;
    }
);

export const CouchImage = styled(Image)(
    ({ theme: { mq } }) => css`
        position: absolute;
        bottom: 36px;
        width: 700px;
        max-width: 700px;
        right: 0;

        ${mq.small} {
            width: 100%;
            max-width: 100%;
        }
    `
);

export const ButtonSignIn = styled(ButtonLink)(
    ({ theme: { mq, spacing, borderRadius } }) => css`
        z-index: 1;
        width: 100%;
        max-width: 180px;
        height: ${spacing['48px']};
        display: flex;
        border-radius: ${borderRadius['300']};
        margin-left: 0;
        margin-right: 0;

        ${mq.small} {
            justify-content: none;
        }
        ${mq.large} {
            margin-left: ${spacing['4px']};
            margin-right: ${spacing['4px']};
        }
    `
);

export const ButtonRegister = styled(ButtonLink)(
    ({ theme: { mq, spacing, borderRadius } }) => css`
        z-index: 1;
        width: 100%;
        max-width: 180px;
        height: ${spacing['48px']};
        display: flex;
        border-radius: ${borderRadius['300']};
        margin-left: 0;
        margin-right: 0;

        ${mq.small} {
            justify-content: none;
        }
        ${mq.large} {
            margin-left: ${spacing['4px']};
            margin-right: ${spacing['4px']};
        }
    `
);

export const ButtonHomeValue = styled(ButtonLink)(
    ({ theme: { mq, spacing, borderRadius } }) => css`
        z-index: 1;
        width: 100%;
        max-width: 250px;
        height: ${spacing['48px']};
        display: flex;
        border-radius: ${borderRadius['300']};
        margin-left: 0;
        margin-right: 0;

        ${mq.small} {
            justify-content: none;
        }
        ${mq.large} {
            margin-left: ${spacing['4px']};
            margin-right: ${spacing['4px']};
        }
    `
);
export const FooterContent = styled.div(
    ({ theme: { spacing, mq } }) => css`
        padding: 0 ${spacing['16px']} ${spacing['64px']} ${spacing['16px']};

        ${mq.small} {
            padding: 0 ${spacing['24px']};
        }
    `
);

export const ButtonWrapper = styled.div(
    ({ theme: { mq, spacing } }) => css`
        display: flex;
        margin-top: ${spacing['32px']};
        justify-content: space-around;

        ${mq.small} {
            margin-left: ${spacing['16px']};
            justify-content: normal;
        }

        ${mq.medium} {
            margin-top: ${spacing['16px']};
            margin-left: ${spacing['24px']};
        }

        ${mq.large} {
            margin-top: ${spacing['24px']};
            margin-left: ${spacing['104px']};
        }
    `
);

export const Title = styled(Heading2)(
    ({ theme: { spacing, mq, colors } }) => css`
        margin-top: ${spacing['24px']};
        color: ${colors['white']};

        ${mq.small} {
            margin-left: ${spacing['16px']};
        }
        ${mq.medium} {
            margin-left: ${spacing['24px']};
        }
        ${mq.large} {
            margin-left: ${spacing['104px']};
        }
    `
);

export const FooterDescription = styled(Text)(
    ({ theme: { spacing, mq, fontSizes, colors } }) => css`
        margin-top: ${spacing['8px']};
        color: ${colors['white']};
        width: 255px;

        ${mq.small} {
            font-size: ${fontSizes[2]};
            margin-left: ${spacing['16px']};
            width: 373px;
        }
        ${mq.medium} {
            font-size: ${fontSizes[2]};
            margin-left: ${spacing['24px']};
        }
        ${mq.large} {
            width: 486px;
            font-size: ${fontSizes[2]};
            margin-left: ${spacing['104px']};
        }
    `
);
